(function($) {

    var globalEasing = Power3.easeOute;
    var __ = {
        body: $('body'),
        window: $(window),
        // Scene Controller
        controller: new ScrollMagic.Controller({}),
        screen: '',
        // Animations
        animations: {
            slide: {
                final: {
                    opacity: 1,
                    transform: 'translate3d(0, 0, 0)',
                    ease: globalEasing
                },
                up: {
                    // opacity: '0',
                    transform: 'translate3d(0, 120% , 0)',
                    ease: globalEasing
                },
                down: {
                    opacity: '1',
                    transform: 'translate3d(0, -100% , 0)',
                    ease: globalEasing
                },
                right: {
                    opacity: '0',
                    transform: 'translate3d(-100%, 0, 0)',
                    ease: globalEasing
                },
                left: {
                    opacity: '0',
                    transform: 'translate3d(100%, 0, 0)',
                    ease: globalEasing
                },
            },
            fade: {
                final: {
                    opacity: 1,
                    transform: 'translate3d(0, 0, 0)',
                    ease: globalEasing
                },
                up: {
                    opacity: '0',
                    transform: 'translate3d(0, 100px , 0)',
                    ease: globalEasing
                },
                down: {
                    opacity: '0',
                    transform: 'translate3d(0, -100px , 0)',
                    ease: globalEasing
                },
                right: {
                    opacity: '0',
                    transform: 'translate3d(-100px, 0, 0)',
                    ease: globalEasing
                },
                left: {
                    opacity: '0',
                    transform: 'translate3d(100px, 0, 0)',
                    ease: globalEasing
                },
            },
            gallery: {
                in: {
                    width: '100vw',
                    height: '100vh',
                    transform: 'translate3d(calc(-1*(100vw-850px) / 2))',
                    ease: globalEasing
                } 
            }
        },
        updateScreenSize: function() {
            var width = $(window).width();
            if (width > 975) {
                __.screen = "large";
            } else if (width > 768) {
                __.screen = "medium";
            } else {
                __.screen = "small";
            }
        },
        getAnimationClass: function(animationClass) {
            if (typeof animationClass === "undefined" || animationClass.length < 1) {
                animationClass = "aos-animate";
            }
        },
        footerAnimations: function() {
            var timeline = new TimelineMax();
            timeline
                .add(TweenMax.fromTo('.pg-footer--line', 2, { width: '0px' }, { width: '100%', ease: Linear.easeNone }))
                .add(TweenMax.fromTo('.pg-footer--logo-link', 1, { opacity: '0' }, { opacity: '1', ease: Linear.easeNone }), "-=0.5")
                .add(TweenMax.staggerFromTo($('.pg-footer--menu--item').toArray(), 1, { opacity: '0' }, { opacity: '1', ease: Linear.easeNone }, 0.2), "-=0.75")
                .add(TweenMax.staggerFromTo($('.pg-footer--location').toArray(), 1, { opacity: '0' }, { opacity: '1', ease: Linear.easeNone }, 0.2), "-=0.75")
                .add(TweenMax.fromTo('.pg-footer--column__three', 1, { opacity: '0' }, { opacity: '1', ease: Linear.easeNone }), "-=0.75")
                .add(TweenMax.fromTo('.pg-footer--column__four', 1, { opacity: '0' }, { opacity: '1', ease: Linear.easeNone }), "-=0.75")
                .add(TweenMax.fromTo('.pg-footer--column__five', 1, { opacity: '0' }, { opacity: '1', ease: Linear.easeNone }), "-=0.75")
                .add(TweenMax.fromTo('.pg-footer--copyright', 1, { opacity: '0' }, { opacity: '1', ease: Linear.easeNone }), "-=0.75")
                .add(TweenMax.fromTo('.pg-footer--madein', 1, { opacity: '0' }, { opacity: '1', ease: Linear.easeNone }), "-=0.75");

            new ScrollMagic.Scene({ triggerElement: '.pg-footer--line', offset: 25, duration: $('.pg-footer').height() - 25, triggerHook: 1 })
                .setTween(timeline)
                .addTo(__.controller);
        },

        // Add a Scroll Trigger to the current scene;
        addScrollTrigger: function(trigger, element, animationClass) {

            animationClass = __.getAnimationClass(animationClass);
            new ScrollMagic.Scene({ triggerElement: trigger, duration: 0, triggerHook: triggerHook, offset: offset })
                .setClassToggle(element, animationClass)
                .addTo(__.controller);
        },

        buildScene: function() {
            $('.j-scroll--section').each(function() {
                var _this = $(this).get(0);
                new ScrollMagic.Scene({ triggerElement: _this, duration: 0, triggerHook: 1, offset: 100 })
                    // .setTween(TweenMax.from(_this, 1, __.animations.fade.up))
                    .setClassToggle(_this, 'aos-animate')
                    .addTo(__.controller);
            });
            __.footerAnimations();
        },
        staggerDisplay: function(splitText, timeline){
            $.each(splitText.lines, function(){
                timeline.staggerFrom( $(this).find('.pga-text--word') , 0.5, {opacity: '0', transform: 'translate3d(0, 100% , 0)', ease: Power3.easeInOut}, 0, '-=0.2' );
            });
        },
        getPreparedText: function(textBlock){
            
            mySplitText = new SplitText(
                textBlock, 
                { 
                    type:"words, chars",
                    linesClass:"pga-text--line pga-text--line__++",
                    wordsClass:"pga-text--word pga-text--word__++",
                    charsClass:"pga-text--char pga-text--char__++",

                }
            );
            return mySplitText;
        },
        splitText: function(textBlock){
            
            mySplitText = new SplitText(
                textBlock, 
                { 
                    type:"lines, words, chars",
                    linesClass:"pga-text--line pga-text--line__++",
                    wordsClass:"pga-text--word pga-text--word__++",
                    charsClass:"pga-text--char pga-text--char__++",

                }
            );
            return mySplitText;
        },
        prepareText: function(textBlock){
            var mySplitText =  __.getPreparedText(textBlock);
            return mySplitText.chars;
        },
        // Add body class for page load
        addPageLoadedClass: function() {
            __.body.addClass('j-page--loaded');
        },
        // Function that runs on load
        onLoad: function() {
            __.window.on('load', function() {
                __.addPageLoadedClass();
                __.onLoadComplete();
            }).resize(__.updateScreenSize);
        },
        // Function that runs on load
        onLoadComplete: function() {
            __.window.on('onLoadComplete', function() {
                __.buildScene();
            });
        },

        
        // Function that runs on load
        completeLoadInAnimation: function() {
            __.body.addClass('j-animation--complete');
            __.window.trigger('onLoadComplete');
        },

        // Function to call to setup functionality
        setup: function() {
            __.updateScreenSize();
            __.onLoad();
        }
    };
    // Attach Toolbox to window //
    if (typeof window._animations === "undefined") {
        window._animations = {};
    } //
    window._animations.base = __;
})(jQuery); // Fully reference jQuery after this point.